import React, { Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as R from "ramda";

const ConnectComponent = (view, presenter) => {
  const observerView = observer(view);

  return class ConnectComponentIntern extends Component {
    static displayName = `ConnectComponent(${view.name}, ${presenter.name})`;

    constructor(props) {
      super(props);
      this._observableProps = observable.box(R.omit("children", props));
      this._presenter = new presenter(this._observableProps);
    }

    componentWillReceiveProps(nextProps) {
      if (!(this._presenter && this._presenter._props)) {
        return;
      }

      this._presenter._props.set(R.omit("children", nextProps));
    }

    componentWillUnmount() {
      if (this._presenter && this._presenter.onEnd) {
        this._presenter.onEnd();
      }
    }

    render() {
      return React.createElement(observerView, {
        ...this.props,
        presenter: this._presenter,
        viewModel: this._presenter.viewModel
      });
    }
  };
};

export default ConnectComponent;



// WEBPACK FOOTER //
// ./src/util/connect-component.js